import React, { Component } from 'react';

export default class Nav extends Component {

	render(){
		return (
			<nav id="nav" className="">
        { this.props.index < 2 &&
          <p id="instruction">Answer the following questions to gauge your innovation impact.</p>
        }
        { this.props.index > this.props.count &&         
          <h2 className="l2-heading">View results</h2>
        }
        {this.props.index <= this.props.count &&
          <h2 className="l2-heading">Question {this.props.index} of {this.props.count}</h2>
        }
        <ul>
          {
            Array.from(Array(this.props.count + 1)).map( (item, i) => {
              return(
                <li key={i} className={this.props.index - 1 === i ? 'active' : ''}>&nbsp;</li> 
              )
            })
          }
        </ul>

      </nav>
		)	
	}
}	
